function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isObject from 'lodash/isObject';
import { lightenDarkenColor } from 'helpers/color';
import Button from 'components/Form/Button';
import stylesVariables from 'common/_variables';
import XIcon from 'svg/x.svg';
var _React_PureComponent;
class Alert extends (_React_PureComponent = React.PureComponent) {
    onAction(evt, action) {
        evt.stopPropagation();
        action();
        if (this.props.onClose) this.props.onClose();
    }
    onClose(evt) {
        evt.stopPropagation();
        if (this.props.onClose) this.props.onClose();
    }
    get style() {
        const { idx, type, isCollapsed } = this.props;
        if (!isCollapsed) {
            return null;
        }
        const color = stylesVariables[`brand-${type}`];
        return {
            marginLeft: `${8 * idx}px`,
            marginRight: `${8 * idx}px`,
            backgroundColor: lightenDarkenColor(color, -25 * idx)
        };
    }
    renderContent() {
        const { message, messageValues } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "alert_content",
            children: isObject(message) && message.id ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                values: messageValues || {}
            })) : message
        });
    }
    renderActions() {
        const { id, actions } = this.props;
        if (!actions) {
            return null;
        }
        return actions.map((action)=>/*#__PURE__*/ _jsx(Button, {
                className: "btn--sm btn--white alert_button",
                isDisabled: action.isDisabled,
                onClick: (evt)=>this.onAction(evt, action.action),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, action.message))
            }, `alert-button-${action.message.id}-${id}`));
    }
    renderCloseBtn() {
        if (!this.props.onClose) {
            return null;
        }
        return /*#__PURE__*/ _jsx(XIcon, {
            className: "alert_close",
            onClick: (evt)=>this.onClose(evt)
        });
    }
    /* eslint-disable jsx-a11y/click-events-have-key-events */ render() {
        const { type } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `alert alert-${type}`,
            style: this.style,
            role: "alert",
            onClick: ()=>this.props.onToggleCollapse && this.props.onToggleCollapse(),
            children: [
                this.renderContent(),
                this.renderActions(),
                this.renderCloseBtn()
            ]
        });
    }
}
_define_property(Alert, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    idx: PropTypes.number,
    type: PropTypes.oneOf([
        'error',
        'success',
        'warning',
        'info'
    ]),
    message: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.string
        }),
        PropTypes.string,
        PropTypes.array
    ]),
    messageValues: PropTypes.object,
    actions: PropTypes.array,
    isCollapsed: PropTypes.bool,
    // Explicit actions
    onClose: PropTypes.func,
    onToggleCollapse: PropTypes.func
});
_define_property(Alert, "defaultProps", {
    idx: 0,
    isCollapsed: false
});
export default Alert;
